import { Box } from "@/components/core-components";
import styled from "styled-components";

export const ResponsiveContainer = styled(Box)`
  max-width: 680px;
  width: 100%;
  margin: ${({ theme }) => theme.spacings.m} auto;
`;
